// Validate required environment variables
const requiredEnvVars = {
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
  issuer: process.env.REACT_APP_OKTA_ISSUER,
}

// Debug logging
console.log('Environment variables check:')
console.log('CLIENT_ID:', process.env.REACT_APP_OKTA_CLIENT_ID ? 'Set' : 'Missing')
console.log('ISSUER:', process.env.REACT_APP_OKTA_ISSUER ? 'Set' : 'Missing')
console.log('NODE_ENV:', process.env.NODE_ENV)

// Check for missing required environment variables
const missingVars = Object.entries(requiredEnvVars)
  .filter(([_, value]) => !value)
  .map(([key]) => key)

if (missingVars.length > 0) {
  console.error('Missing required Okta environment variables:', missingVars)
  console.error('Please set the following in your Heroku config vars:')
  missingVars.forEach(varName => {
    console.error(`- REACT_APP_OKTA_${varName.toUpperCase()}`)
  })
} else {
  console.log('All required Okta environment variables are set')
}

export const oktaConfig = {
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID || '',
  issuer: process.env.REACT_APP_OKTA_ISSUER || '',
  redirectUri: process.env.REACT_APP_OKTA_REDIRECT_URI || `${window.location.origin}/auth/callback`,
  postLogoutRedirectUri: process.env.REACT_APP_OKTA_POST_LOGOUT_REDIRECT_URI || `${window.location.origin}/auth/logout`,
  scopes: ['openid', 'profile', 'email', 'groups'],
  pkce: true,
  disableHttpsCheck: process.env.NODE_ENV === 'development',
  tokenManager: {
    autoRenew: true,
    secure: process.env.NODE_ENV === 'production',
    storageManager: {
      token: {
        storageTypes: ['localStorage', 'sessionStorage', 'cookie']
      }
    }
  },
  services: {
    autoRenew: true,
    autoRemove: true
  }
}

export const requiredGroups = [
  'Barry\'s-Super-Admin',
  'Barry\'s-Admin-Portal-Admins',
  'Barry\'s-Admin-Portal-Users',
  // Regional-only groups stay fail-closed until the same customer scope is
  // enforced by every backend PII route. Browser-only scoping is insufficient.
]

export const superAdminGroups = [
  'Barry\'s-Super-Admin'
]

export const adminGroups = [
  'Barry\'s-Super-Admin',
  'Barry\'s-Admin-Portal-Admins'
]

export const ukGroups = [
  'UK Users'
]

export const dublinGroups = [
  'Dublin Users'
]

// Studio-region scopes: members of these groups can only view/manage clients
// whose home_studio attribute matches one of the keywords (substring match,
// case-insensitive) or whose MT home_location.id is in the id list.
export const regionMiamiGroups = ['region_miami']
export const regionMiamiHomeStudioKeywords = ['aventura', 'miami beach', 'midtown miami']
export const regionMiamiHomeLocationIds = [9631, 9616, 9615]

// `region` is the user-facing label rendered in the access-denied notice.
export const STUDIO_REGION_SCOPES = [
  {
    groups: regionMiamiGroups,
    region: 'Miami',
    keywords: regionMiamiHomeStudioKeywords,
    locationIds: regionMiamiHomeLocationIds,
  },
] as const

export type StudioRegionScope = (typeof STUDIO_REGION_SCOPES)[number]
